import { RouteType } from "../models/enum";

const OFFLINE_WORK_SEGMENTS = new Set<string>([RouteType.PENDING, RouteType.RATINGS]);

/**
 * Normalize a URL or path to a pathname without query/hash/trailing slash.
 * Accepts absolute URLs, router state urls, or pathnames.
 */
export function normalizeAppPath(url: string): string {
	const trimmed = (url ?? "").trim();
	if (!trimmed) {
		return "";
	}

	let path = trimmed;
	try {
		if (/^https?:\/\//i.test(trimmed)) {
			path = new URL(trimmed).pathname;
		} else {
			path = trimmed.split("?")[0].split("#")[0];
		}
	} catch {
		path = trimmed.split("?")[0].split("#")[0];
	}

	if (!path.startsWith("/")) {
		path = `/${path}`;
	}

	return path.replace(/\/+$/, "") || "/";
}

/**
 * True for pending list and ratings form/draft routes where expired
 * sessions must not force a login redirect while a cached profile exists.
 */
export function isOfflineWorkRoute(url: string): boolean {
	const path = normalizeAppPath(url);
	const firstSegment = path.split("/").filter(Boolean)[0] ?? "";
	return OFFLINE_WORK_SEGMENTS.has(firstSegment);
}
